import * as React from "react";

const CheckMarkIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M22.107 11.9998C22.107 6.41828 17.5823 1.89355 12.0008 1.89355C6.41925 1.89355 1.89453 6.41828 1.89453 11.9998C1.89453 17.5813 6.41925 22.1061 12.0008 22.1061C17.5823 22.1061 22.107 17.5813 22.107 11.9998Z" stroke="#0C9BED" strokeWidth="2" strokeMiterlimit="10"/>
        <path d="M15.7178 9.56883L10.8565 14.4302L8.42578 11.9995" stroke="#0C9BED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
export default CheckMarkIcon;